/* eslint-disable @typescript-eslint/member-ordering */
import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { BreadcrumbItem } from '../../models/breadcrumb/breadcrumb-item';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
    standalone: false
})
export class BreadcrumbComponent implements OnInit {

  @Input() items: BreadcrumbItem[];

  constructor(private authService: AuthService) { }

  tenant: string;

  ngOnInit(): void {
    this.tenant = this.authService.principal.provider;
  }
}
